module.exports = __webpack_public_path__ + "media/images/dish-1-5228674f6ee05ceebb3283534fc9a651.webp";